/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();

import { useEffect } from 'react'

import { initialiseGoogleTagManager } from '@/lib/analytics/google-tag-manager'

/**
 * Loads Google Tag Manager once per page. Render it before the page content, so its effect runs before any page
 * effect that pushes tracking events.
 */
const GoogleTagManager = () => {
  const tagManagerId = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID

  useEffect(() => {
    if (tagManagerId) {
      initialiseGoogleTagManager(tagManagerId)
    }
  }, [tagManagerId])

  return null
}

export { GoogleTagManager }
